import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/OptionsMenu/options-menu';
import { css } from '@patternfly/react-styles';
import { DropdownItem, DropdownDirection, DropdownWithContext, DropdownContext } from '../Dropdown';
import CheckIcon from '@patternfly/react-icons/dist/js/icons/check-icon';
import { OptionsToggle } from './OptionsToggle';
export var PaginationOptionsMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PaginationOptionsMenu, _React$Component);

  function PaginationOptionsMenu(props) {
    var _this;

    _classCallCheck(this, PaginationOptionsMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PaginationOptionsMenu).call(this, props));
    _this.parentRef = React.createRef();

    _this.onToggle = function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    };

    _this.onSelect = function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    _this.handleNewPerPage = function (_evt, newPerPage) {
      var _this$props = _this.props,
          page = _this$props.page,
          onPerPageSelect = _this$props.onPerPageSelect,
          itemCount = _this$props.itemCount,
          defaultToFullPage = _this$props.defaultToFullPage;
      var newPage = page;

      while (Math.ceil(itemCount / newPerPage) < newPage) {
        newPage--;
      }

      if (defaultToFullPage) {
        if (itemCount / newPerPage !== newPage) {
          while (newPage > 1 && itemCount - newPerPage * newPage < 0) {
            newPage--;
          }
        }
      }

      var startIdx = (newPage - 1) * newPerPage;
      var endIdx = newPage * newPerPage;
      return onPerPageSelect(_evt, newPerPage, newPage, startIdx, endIdx);
    };

    _this.renderItems = function () {
      var _this$props2 = _this.props,
          perPageOptions = _this$props2.perPageOptions,
          perPage = _this$props2.perPage,
          perPageSuffix = _this$props2.perPageSuffix;
      return perPageOptions.map(function (_ref) {
        var value = _ref.value,
            title = _ref.title;
        return React.createElement(DropdownItem, {
          key: value,
          component: "button",
          "data-action": "per-page-".concat(value),
          className: css(perPage === value && 'pf-m-selected'),
          onClick: function onClick(event) {
            return _this.handleNewPerPage(event, value);
          }
        }, title, " ".concat(perPageSuffix), perPage === value && React.createElement("div", {
          className: css(styles.optionsMenuMenuItemIcon)
        }, React.createElement(CheckIcon, null)));
      });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(PaginationOptionsMenu, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          widgetId = _this$props3.widgetId,
          isDisabled = _this$props3.isDisabled,
          itemsPerPageTitle = _this$props3.itemsPerPageTitle,
          dropDirection = _this$props3.dropDirection,
          optionsToggle = _this$props3.optionsToggle,
          perPageOptions = _this$props3.perPageOptions,
          toggleTemplate = _this$props3.toggleTemplate,
          firstIndex = _this$props3.firstIndex,
          lastIndex = _this$props3.lastIndex,
          itemCount = _this$props3.itemCount,
          itemsTitle = _this$props3.itemsTitle;
      var isOpen = this.state.isOpen;
      return React.createElement(DropdownContext.Provider, {
        value: {
          id: widgetId,
          onSelect: this.onSelect,
          toggleIndicatorClass: styles.optionsMenuToggleButtonIcon,
          toggleTextClass: styles.optionsMenuToggleText,
          menuClass: styles.optionsMenuMenu,
          itemClass: styles.optionsMenuMenuItem,
          toggleClass: ' ',
          baseClass: styles.optionsMenu,
          disabledClass: styles.modifiers.disabled,
          menuComponent: 'ul',
          baseComponent: 'div'
        }
      }, React.createElement(DropdownWithContext, {
        direction: dropDirection,
        isOpen: isOpen,
        toggle: React.createElement(OptionsToggle, {
          optionsToggle: optionsToggle,
          itemsPerPageTitle: itemsPerPageTitle,
          showToggle: perPageOptions && perPageOptions.length > 0,
          onToggle: this.onToggle,
          isOpen: isOpen,
          widgetId: widgetId,
          firstIndex: firstIndex,
          lastIndex: lastIndex,
          itemCount: itemCount,
          itemsTitle: itemsTitle,
          toggleTemplate: toggleTemplate,
          parentRef: this.parentRef.current,
          isDisabled: isDisabled
        }),
        dropdownItems: this.renderItems(),
        isPlain: true
      }));
    }
  }]);

  return PaginationOptionsMenu;
}(React.Component);
PaginationOptionsMenu.defaultProps = {
  className: '',
  widgetId: '',
  isDisabled: false,
  dropDirection: DropdownDirection.down,
  perPageOptions: [],
  itemsPerPageTitle: 'Items per page',
  perPageSuffix: 'per page',
  optionsToggle: 'Select',
  perPage: 0,
  firstIndex: 0,
  lastIndex: 0,
  defaultToFullPage: false,
  itemCount: 0,
  itemsTitle: 'items',
  toggleTemplate: function toggleTemplate(_ref2) {
    var firstIndex = _ref2.firstIndex,
        lastIndex = _ref2.lastIndex,
        itemCount = _ref2.itemCount,
        itemsTitle = _ref2.itemsTitle;
    return React.createElement(React.Fragment, null, React.createElement("b", null, firstIndex, " - ", lastIndex), ' ', "of", React.createElement("b", null, itemCount), " ", itemsTitle);
  },
  onPerPageSelect: function onPerPageSelect() {
    return null;
  }
};